"use strict";

var Onboarding = {
  onload: document.addEventListener('DOMContentLoaded', function () {
    Onboarding.init();
  }),
  init: function init() {
    this.bind();
    this.stepOnBoarding();
  },
  bind: function bind() {
    $(document).on('click', 'a.resend-verify-email', function (event) {
      event.preventDefault();
      $(this).prop('disabled', true);
      Onboarding.ajax.resendVerificationEmail($(this));
    }).on('change', 'select#onboarding-languages', function (event) {
      event.preventDefault();
      Onboarding.ajax.setLanguage($(this).val());
    }).on('change', 'select#onboarding-payout-options', function (event) {
      event.preventDefault();
      Onboarding.ajax.setPayoutOptions($(this).val());
    }).on('change', '[name="payout-options"]', function (event) {
      event.preventDefault();
      var selectedInput = $('[name="payout-options"]:checked');
      var infoBlock = $(this).closest('div.cash-payment-popup-content').find('.info');
      infoBlock.addClass('d-none');
      infoBlock.find('p').addClass('d-none');
      if (parseInt(selectedInput.val()) > 0) {
        infoBlock.removeClass('d-none');
        infoBlock.find("p[data-id=\"".concat(selectedInput.attr('id'), "\"]")).removeClass('d-none');
      }
      Onboarding.ajax.setPayoutOptions(selectedInput.val());
    }).on('change', 'select#onboarding-timezone', function (event) {
      event.preventDefault();
      Onboarding.ajax.setTimezone($(this).val(), $('select#onboarding-timezone option:selected').attr('data-info'));
    }).on('change', 'select#onboarding-question', function (event) {
      event.preventDefault();
      var block = $('.how-did-you-find-service');
      if ($(this).val() === 'Other') {
        block.show();
        block.find('input').prop('disabled', false);
      } else {
        block.hide();
        block.find('input').prop('disabled', true);
      }
    }).on('change', '[name="interested"]', function (event) {
      event.preventDefault();
      Onboarding.ajax.setOnBoardingInterested($(this).val());
    });
    $(document).on('click', '.submit-onboarding-data', function (event) {
      event.preventDefault();
      $('.confirmation').show();
      $(".step").removeClass("active-height");
      Onboarding.ajax.setOnBoardingQuestion();
      setTimeout(function () {
        window.location.replace($('#go-to-main-page').attr('href'));
      }, 10000);
    }).on('click', '.save-global-preferences', function (event) {
      event.preventDefault();
      Notify.successfulNotification($(this).attr('data-text'));
    }).on('click', '.save-payout-options, .cash-payment-popup-close', function (event) {
      event.preventDefault();
      $('.cash-payment-popup').removeClass('active');
      Notify.successfulNotification($(this).attr('data-text'));
      Onboarding.ajax.setPayoutOptions($('[name="payout-options"]:checked').val());
    });
  },
  getUsersAnswer: function getUsersAnswer() {
    var answer = '';
    var select = $('#onboarding-question');
    if (select.val() === 'Other') {
      answer = $('#onboarding_your_answer').val();
    } else {
      answer = select.val();
    }
    return answer;
  },
  stepOnBoarding: function stepOnBoarding() {
    var slidePage = $(".slide-step");
    var progress = $(".onboarding__progress-bar");
    var bullet = $(".onboarding__line");
    var pages = $(".step");
    var nextButtons = $(".next");
    var prevButtons = $(".back");
    var stepsNumber = pages.length;
    var current = 1;
    for (var i = 0; i < nextButtons.length; i++) {
      nextButtons[i].addEventListener("click", function (event) {
        event.preventDefault();
        slidePage.css('margin-left', "-".concat(100 / stepsNumber * current, "%"));
        bullet[current].classList.add("active");
        current += 1;
        var bulletActive = $(".active");
        progress.css('width', "".concat(bulletActive.length / (bullet.length - 1) * 100 + '%'));
        pages[current - 1].classList.add("active-height");
        pages[current - 2].classList.remove("active-height");
      });
    }
    for (var _i = 0; _i < prevButtons.length; _i++) {
      prevButtons[_i].addEventListener("click", function (event) {
        event.preventDefault();
        slidePage.css('margin-left', "-".concat(100 / stepsNumber * (current - 2), "%"));
        bullet[current - 1].classList.remove("active");
        var bulletActive = $(".active");
        progress.css('width', "".concat(bulletActive.length / (bullet.length - 1) * 100 + '%'));
        pages[current - 2].classList.add("active-height");
        pages[current - 1].classList.remove("active-height");
        current -= 1;
      });
    }
  },
  ajax: {
    obj: {},
    url: AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    resendVerificationEmail: function resendVerificationEmail(btn) {
      this.obj.method = 'resendVerificationEmail';
      this.send(function (answer) {
        setTimeout(function () {
          btn.prop('disabled', false);
        }, 30000);
        Notify.successfulNotification(answer.text);
      }, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    setLanguage: function setLanguage(language) {
      this.obj.method = 'setLanguage';
      this.obj.language = language;
      this.send(function (answer) {}, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    setOnBoardingInterested: function setOnBoardingInterested(answer) {
      this.obj.method = 'setOnBoardingInterested';
      this.obj.answer = answer;
      this.send(function (answer) {}, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    setTimezone: function setTimezone(timezone, info) {
      this.obj.method = 'setTimezone';
      this.obj.timezone = timezone;
      this.obj.info = info;
      this.send(function (answer) {}, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    setPayoutOptions: function setPayoutOptions(value) {
      this.obj.method = 'setPayoutOptions';
      this.obj.value = value;
      this.send(function (answer) {}, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    },
    setOnBoardingQuestion: function setOnBoardingQuestion() {
      this.obj.method = 'setOnBoardingQuestion';
      this.obj.answer = Onboarding.getUsersAnswer();
      this.send(function (answer) {}, function (answer) {
        Notify.dangerNotification(answer.text);
      });
    }
  }
};